/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface JustPortfolioDeleteViewModel
 */
export interface JustPortfolioDeleteViewModel {
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioDeleteViewModel
     */
    justPortfolioId: number;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioDeleteViewModel
     */
    productThirdPartyRelationId?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof JustPortfolioDeleteViewModel
     */
    spousalInd?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof JustPortfolioDeleteViewModel
     */
    spousalPerc?: number;
}

/**
 * Check if a given object implements the JustPortfolioDeleteViewModel interface.
 */
export function instanceOfJustPortfolioDeleteViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "justPortfolioId" in value;

    return isInstance;
}

export function JustPortfolioDeleteViewModelFromJSON(json: any): JustPortfolioDeleteViewModel {
    return JustPortfolioDeleteViewModelFromJSONTyped(json, false);
}

export function JustPortfolioDeleteViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JustPortfolioDeleteViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'justPortfolioId': json['JustPortfolioId'],
        'productThirdPartyRelationId': !exists(json, 'ProductThirdPartyRelationId') ? undefined : json['ProductThirdPartyRelationId'],
        'spousalInd': !exists(json, 'SpousalInd') ? undefined : IAPYESORNOFromJSON(json['SpousalInd']),
        'spousalPerc': !exists(json, 'SpousalPerc') ? undefined : json['SpousalPerc'],
    };
}

export function JustPortfolioDeleteViewModelToJSON(value?: JustPortfolioDeleteViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'JustPortfolioId': value.justPortfolioId,
        'ProductThirdPartyRelationId': value.productThirdPartyRelationId,
        'SpousalInd': IAPYESORNOToJSON(value.spousalInd),
        'SpousalPerc': value.spousalPerc,
    };
}

